export const SET_EXTERNALHOME_SELECTED_CONTRACT = "SET_EXTERNALHOME_SELECTED_CONTRACT";
export function action_setExternalHome_SelectedContract(contract) {
	return { type: SET_EXTERNALHOME_SELECTED_CONTRACT, payload: contract };
}

export const SET_EXTERNALHOME_FIRE_GET_DATA = "SET_EXTERNALHOME_FIRE_GET_DATA";
export function action_setExternalHome_FireGetData(loaded) {
	return { type: SET_EXTERNALHOME_FIRE_GET_DATA, payload: loaded };
}

export const SET_EXTERNALHOME_CONTRACTS = "SET_EXTERNALHOME_CONTRACTS";
export function action_setExternalHome_Contracts(contracts) {
	return { type: SET_EXTERNALHOME_CONTRACTS, payload: contracts };
}

export const SET_EXTERNALHOME_DATASERIES = "SET_EXTERNALHOME_DATASERIES";
export function action_setExternalHome_Dataseries(dataseries) {
	return { type: SET_EXTERNALHOME_DATASERIES, payload: dataseries };
}

export const SET_DEFAULT_SELECTED_FILTER_BINDED = "SET_DEFAULT_SELECTED_FILTER_BINDED";
export function action_setDefaultSelectedFiltersBinded(binded) {
	return { type: SET_DEFAULT_SELECTED_FILTER_BINDED, payload: binded };
}